import ResponsiveContainerComponent from '@wix/thunderbolt-elements/src/thunderbolt-core-components/ResponsiveContainer/viewer/ResponsiveContainer';


const ResponsiveContainer = {
  component: ResponsiveContainerComponent
};


export const components = {
  ['ResponsiveContainer']: ResponsiveContainer
};

